import * as definitions from '@database/common-schema/definitions';
export const CaListResponseSchema = {
    type: 'object',
    title: 'ICaListResponse',
    schemaType: 'request-response',
    additionalProperties: false,
    properties: {
        list: {
            type: 'array',
        },
        count: { type: 'number', minimum: 0 },
        pages: { type: 'number', minimum: 0 },
        page: { type: 'number', minimum: 0 },
        next: { type: 'string' },
        previous: { type: 'string' },
    },
    required: ['list', 'count', 'pages', 'page'],
};
export const CaPublishTypeEnum = {
    schemaType: 'enum',
    enum: ['auto', 'manual', 'all', 'none'],
    description: 'Enum of publish types, including also all and none options.',
};
export const PartnerTypeEnum = {
    schemaType: 'enum',
    enum: ['testpartner', 'contentpartner', 'bfbrand', 'agenturen', 'spezialpartner'],
    description: 'Enum of different partner types.',
};
export const CaPublishConfigSchema = {
    type: 'object',
    schemaType: 'block',
    title: 'ICaPublishConfig',
    additionalProperties: false,
    properties: {
        brand: definitions.brand,
        autopublish: { type: 'boolean', description: 'Is content autopublished on the brand?', default: false },
        hideFromNewsTicker: CaPublishTypeEnum,
        hideFromMostRecent: CaPublishTypeEnum,
        adsEnabled: CaPublishTypeEnum,
        outstreamEnabled: CaPublishTypeEnum,
        isNoIndex: CaPublishTypeEnum,
        unpublishAfterDays: {
            type: 'number',
        },
        unpublishBoughtAfterDays: {
            type: 'number',
        },
        jobGroup: { type: 'string', description: 'Job group number (not UUID)' },
        channelUuid: { ...definitions.uuid, description: 'Primary channel UUID' },
        secondaryChannelUuids: {
            type: 'array',
            items: definitions.uuid,
            description: 'Secondary channel UUIDs',
        },
        defaultAuthorUuids: {
            type: 'array',
            items: definitions.uuid,
            description: 'Uuids of authors used as default ones (only applicable to agency type partners).',
        },
    },
    required: ['brand', 'autopublish', 'hideFromNewsTicker', 'hideFromMostRecent', 'adsEnabled', 'outstreamEnabled', 'isNoIndex'],
};
//# sourceMappingURL=ca.common.model.schema.js.map